module.exports = __webpack_public_path__ + "img/10.1.f0502be3.jpg";